import * as actionTypes from "../actions/actionTypes";

const initState = {
    showContactNow: false,
    dealerId : null,
    dealerName: null,
    dealerNumber: null
}

const toggelContactNow = (state, action) => {
    return {
        ...state,
        showContactNow: !state.showContactNow,
        dealerId : action.dealerId,
        dealerName: action.dealerName,
        dealerNumber: action.dealerNumber
    }
};

const createNewChat = (state, action)=>{
    return {
        ...state
    }
};

const Reducer = (state = initState, action) => {
    switch (action.type) {
        case actionTypes.TOGGEL_CONTACT_NOW: return toggelContactNow(state, action)
        case actionTypes.CREATE_NEW_CHAT: return createNewChat(state, action)
        default: return { ...state }
    }
};

export default Reducer;